window.ENV_CONFIG = {
  baseUrl: process.env.API_URL,
  feedbackDuration: 2000,
  coalaVersion: process.env.VERSION,
  coalaBuild: process.env.BUILD_NUM,
  coalaBranch: process.env.BRANCH_NAME,
  coalaBuildTime: process.env.BUILD_TIME,
  defaultTableItemsPerPage: 10,
  autoLogoutMinutes: 20,
  maintenanceMode: false,
  azureSubscriptionId: '9edc3a90-c8e5-49a9-8a7a-f3f783057de6',
  monitoringCenter: process.env.MONITORING_CENTER,
  defaultNationId: process.env.DEFAULT_NATION
};
